import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterModule } from "@angular/router";
import { Page } from "@models/page";
import { Sale } from "@models/sale";
import { DashboardCardComponent } from "@shared/components/cards/dashboard-card/dashboard-card.component";
import { PaginatorModule, PaginatorState } from "primeng/paginator";
import { SkeletonModule } from "primeng/skeleton";
import { TableModule } from "primeng/table";
import { PaymentMethodPipe } from "../../pipes/payment-method.pipe";
import { PaymentStatusPipe } from "../../pipes/payment-status.pipe";
import { EventImageComponent } from "../event-image/event-image.component";

@Component({
  selector: "app-last-sales-table",
  imports: [
    CommonModule,
    SkeletonModule,
    MatIconModule,
    DashboardCardComponent,
    RouterModule,
    TableModule,
    MatButtonModule,
    PaymentMethodPipe,
    PaymentStatusPipe,
    MatTooltipModule,
    EventImageComponent,
    PaginatorModule,
  ],
  templateUrl: "./last-sales-table.component.html",
  styleUrl: "./last-sales-table.component.scss",
})
export class LastSalesTableComponent {
  @Input({ required: true }) sales: Page<Sale> | null = null;
  @Input() title = "Últimas Vendas";
  @Input() showSeeAllLink = true;
  @Input() showPagination = false;
  @Input() first = 0;
  @Input() rows = 5;

  @Output() saleDetailsClick = new EventEmitter<number>();
  @Output() pageChange = new EventEmitter<PaginatorState>();

  handlePageChange(page: PaginatorState) {
    this.pageChange.emit(page);
  }
}
